<template>
    <div
        class="d-flex flex-nowrap gap-2"
        @dblclick="editTime"
    >
        <DateComp
            :value="value"
            format="DATETIMEMS3"
        />
        <ButtonComp
            class="btn-sm"
            buttonType="Edit"
            @click="editTime"
        />
    </div>
</template>

<script setup lang="ts">
import { DateComp, ButtonComp, AddEditTime } from '@/components';
import { AddEditTimeRequest } from '../Time/AddEditTimeRequest';
import type { ContestantAndRaceContestantTime } from '@/objects/generated';
import { useDialogBuilder } from '@/composeables/dialog/dialogbuilder';
import { ref } from 'vue';
import { useContestantStore } from '@/stores';

const props = defineProps<{
    value: Date | null;

    row: ContestantAndRaceContestantTime;

    // A callback for when the save button is clicked
    saveCallback?: (request: AddEditTimeRequest) => void;
}>();

const contestantStore = useContestantStore();

const editTime = () => {
    const request = ref(
        new AddEditTimeRequest({
            time: props.row.Time,
            raceContestantId: props.row.RaceContestantID,
            bib: props.row.ContestantID == null ? null : (contestantStore.GetContestantById(props.row.ContestantID)?.Bib ?? null),
            stationId: props.row.StationID,
            tuid: props.row.TUID,
        }),
    );

    // TODO: Use globaldialog OpenAddTimeModal (when that has support for selecting the station ID)
    useDialogBuilder()
        .withTitle('contestanttime.edittime')
        .withBodyComponent(AddEditTime, {
            vmodel: request,
        })
        .withCancelButton({
            action: () => {},
        })
        .withSaveButton({
            action: async () => {
                if (props.saveCallback) {
                    props.saveCallback(request.value);
                }
                return true;
            },
        })
        .withOptions({
            Size: 'md',
        })
        .Open();
};
</script>
